import { Component } from '@angular/core';
import { EmptyShoppingCartComponent } from '@components/svg-icons/empty-shopping-cart/empty-shopping-cart.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'ln-empty-shopping-cart-card',
  imports: [EmptyShoppingCartComponent, TranslocoPipe],
  templateUrl: './empty-shopping-cart-card.component.html',
  styleUrl: './empty-shopping-cart-card.component.css',
})
export class EmptyShoppingCartCardComponent {}
